import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Circles = lazy(() => import("@/pages/Circles"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/circles")({
  component: () => (
    <ProtectedRoute>
      <Circles />
    </ProtectedRoute>
  ),
});
